import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { BatchService } from './batch.service';
import { Batch } from '../../interfaces/batch/batch.interface';
import { environment } from '../../../../../environments/environment.dev';
import { BatchSearchParam } from '../../interfaces/batch/batch-search-param.interface';
import { convertToHttpParams } from '../../../../core/interfaces/common-search-param.interface';
import { PageResponse } from '../../../../core/interfaces/page-response.interface';
import { ApiResponse } from '../../../../core/interfaces/ApiResponse';

@Injectable({
    providedIn: 'root'
})
export class BatchApiService extends BatchService {
    private http = inject(HttpClient);
    private readonly baseUrl = `${environment.apiBaseUrl}v1/batch/institution-batch`;

    constructor() {
        super();
    }

    override findAll(searchParam: BatchSearchParam): Observable<PageResponse<Batch>> {
        const institutionUniqueId = searchParam.institutionId;
        return this.wrapRequest(
            this.http.get<ApiResponse<PageResponse<Batch>>>(`${this.baseUrl}/${institutionUniqueId}`, { headers: this.headers, params: convertToHttpParams(searchParam) })
                .pipe(map(res => res.response))
        );
    }

    override find(id: string): Observable<Batch> {
        return this.wrapRequest(
            this.http.get<ApiResponse<Batch>>(`${this.baseUrl}/${id}`, { headers: this.headers })
                .pipe(map(res => res.response))
        );
    }

    override create(data: Partial<Batch>): Observable<Batch> {
        return this.wrapRequest(
            this.http.post<ApiResponse<Batch>>(this.baseUrl, data, { headers: this.headers })
                .pipe(map(res => res.response))
        );
    }

    override update(id: string, data: Partial<Batch>): Observable<Batch> {
        return this.wrapRequest(
            this.http.put<ApiResponse<Batch>>(`${this.baseUrl}/${id}`, data, { headers: this.headers })
                .pipe(map(res => res.response))
        );
    }

    override delete(id: string): Observable<void> {
        return this.wrapRequest(
            this.http.delete<void>(`${this.baseUrl}/${id}`, { headers: this.headers })
        );
    }
    override uploadStudents(institutionUniqueId: string, institutionBatchUniqueId: string, file: File): Observable<any> {
        const formData = new FormData();
        formData.append('file', file);
        return this.wrapRequest(
            this.http.post<ApiResponse<any>>(`${this.baseUrl}/institution/student/upload/${institutionUniqueId}/${institutionBatchUniqueId}`, formData, {
                headers: this.headers.delete('Content-Type')
            }).pipe(map(res => res.response))
        );
    }
}
